import { Injectable } from '@angular/core';
import { global } from '../../models/global';
import { Http, Response, RequestOptions, Request, Headers, ResponseContentType } from '@angular/http';
import 'rxjs/add/Observable/throw';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { debounce } from 'rxjs/operator/debounce';
import { DebugElement } from '@angular/core/src/debug/debug_node';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import 'rxjs/add/Observable/throw';

@Injectable({
  providedIn: 'root'
})
export class FinalRequirementService {
  ROOT_URL: string = "";
  constructor(private http: Http) {
    let g: global = new global();
    this.ROOT_URL = g.getApiUrl();
  }

  getFinalRequirementDetails(pageno:number,product:string,crop:string,userID: string, roleID: string,sbuCode: string,divisionCode: string, zoneCode: string,regionCode: string, reqType: string,rmhCode:string,isProduct:boolean,year: any, status: string): Observable<any> {
    debugger;
    let url = this.ROOT_URL + '/api/FinalRequirement/GetFinalRequirementDetails';
    let body = { "pageno":pageno,"product":product,"crop":crop,"userID": userID, "roleID": roleID, "sbuCode": sbuCode,"divisionCode": divisionCode,"zoneCode": zoneCode,"regionCode": regionCode,"reqType": reqType,"rmhCode":rmhCode,"isProduct":isProduct,"year":year,"status":status};
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8','Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: body,
    })
    return this.http.request(new Request(requestoptions))
      .map(response => <any>(<Response>response).json());
  }

  approveFinalRequirementDetails(item: any, userID: string, roleID: string, reqType: string, regionCode: string,isRejected: boolean,comment:string, year:number,product: string,crop: string,status:string): Observable<any> {
    let m_model = { 'model': item };
    let m_userid = { 'userId': userID };
    let m_roleId = { 'roleId': roleID };
    let m_reqType = { 'requirementType': reqType };
    let m_regionCode = { 'regionCode': regionCode };
    let m_isRejected = { 'isRejected': isRejected };
    let m_comment = { 'comment': comment };
    let m_year= { 'year': year };
    let m_product= { 'product': product };
    let m_crop= { 'crop': crop };
    let m_status= { 'status': status };
    let url = this.ROOT_URL + '/api/FinalRequirement/ApproveFinalReqDetails';
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8','Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: { model: m_model, userid: m_userid, roleid: m_roleId, requirementType: m_reqType, regionCode: m_regionCode, isRejected: m_isRejected , comment:m_comment, year:m_year,product: m_product,crop: m_crop,status : m_status},
    })
    return this.http.request(new Request(requestoptions))
      .map(response => <any>(<Response>response).json());
  }

  getApprovalHistory(currentPageForHistory: number, userID: string, roleID: string, reqType: string, sbuCode: string,divisionCode: string, zoneCode: string,regionCode: string,rmhCode:string,year:any): Observable<any> {
    let url = this.ROOT_URL + '/api/FinalRequirement/GetApprovalHistory';
    let body = { "pageNo": currentPageForHistory, "userID": userID, "roleID": roleID, "reqType": reqType, "sbuCode": sbuCode,"divisionCode": divisionCode,"zoneCode": zoneCode,"regionCode": regionCode,"rmhCode": rmhCode,"year":year};
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8','Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: url,
      headers: headers,
      body: body,
    })
    return this.http.request(new Request(requestoptions))
      .map(response => <any>(<Response>response).json());
  }
  getFinalRequirementDetailsExcel(pageNoForExcel:number, userID: string, roleID: string,sbuCode: string,divisionCode: string, zoneCode: string,regionCode: string, reqType: string,rmhCode:string,isProduct:boolean,year:number, status: string): Observable<any> {
    let _body = {"pageNo":pageNoForExcel, "userID": userID, "roleID": roleID, "sbuCode": sbuCode,"divisionCode": divisionCode,"zoneCode": zoneCode,"regionCode": regionCode,"reqType": reqType,"rmhCode":rmhCode ,"isProduct":isProduct,"year":year,"status":status};
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
      method: 'POST',
      url: this.ROOT_URL + "/api/FinalRequirement/GetFinalRequirementExcel",
      headers: headers,
      body: _body,
      responseType: ResponseContentType.Blob
    });
    return this.http.request(new Request(requestoptions))
      .map((res: Response) => {
        return res;
      });
  }
  getStatus(userId: string, roleId: string): Observable<any> {
    let url = this.ROOT_URL + '/api/FinalRequirement/GetStatus';
    let body = { "userId": userId, "roleId": roleId };
    let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization': 'Bearer ' + localStorage.getItem('dsu_token') });
    let requestoptions: RequestOptions = new RequestOptions({
        method: 'POST',
        url: url,
        headers: headers,
        body: body,
    })
    return this.http.request(new Request(requestoptions))
        .map(response => <any>(<Response>response).json());
}



}
